import { basePropertiesSchema } from '../base-schema-properties'
import {
  isBlankSchema,
  shadowSchema,
  titlePropertiesSchema,
  titleSizeSchema,
} from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Latest News',
  description: 'Block with list of news',
  type: 'object',
  'ui:options': {
    onlyShowIfDependent: true,
  },
  dependencies: {
    title: ['titleAlign', 'hideOnEmbed'],
  },
  properties: {
    ...basePropertiesSchema,
    ...titlePropertiesSchema,
    ...titleSizeSchema,
    ...shadowSchema,
    viewAllText: {
      title: 'View all text',
      type: 'string',
      default: 'View all',
    },
    viewAllLink: {
      title: 'View all link',
      type: 'string',
      default: '/news',
    },
    ...isBlankSchema,
  },
}
